export const getImageURL = (image: string | File | undefined) => {
	if (typeof image === 'string') {
		return image;
	}
	if (image === undefined) {
		return '';
	}
	return URL.createObjectURL(image);
};
